import React, {useRef, useEffect} from 'react'

import {CrossIcon} from 'src/components/icons'
import {Box, Flex} from 'src/components/Box'
import * as breakpoints from 'src/styles/mediaQuery'
import Card from 'src/components/Card'
import {Body, Header1} from 'src/components/text'
import ButtonLink from 'src/components/ButtonLink'
import {gradientBorder} from 'src/styles/borders'
import {gradients} from 'src/styles'

type LoginModalProps = {
  showModal: boolean
  closeModal: () => void
  locationPathname: string
  children: React.ReactNode
  fromModal: string
}

const LoginModal: React.FC<LoginModalProps> = ({
  showModal,
  closeModal,
  locationPathname,
  children,
  fromModal,
}) => {
  const modalRef = useRef(null)

  useEffect(() => {
    const handleClickOutsideModal = (event: MouseEvent) => {
      const modalElement = modalRef.current as HTMLElement | null
      const clickedElement = event.target as HTMLElement

      const hasLoginModalAttribute =
        clickedElement.closest("[data-modal='login-modal']") !== null

      if (
        modalElement &&
        !modalElement.contains(clickedElement) &&
        !hasLoginModalAttribute
      ) {
        closeModal()
      }
    }

    if (showModal) {
      document.addEventListener('click', handleClickOutsideModal)
    }

    return () => {
      document.removeEventListener('click', handleClickOutsideModal)
    }
  }, [showModal, closeModal])

  return (
    <>
      {showModal && (
        <Box
          ref={modalRef}
          position="absolute"
          zIndex={1}
          mt={200}
          alignSelf="center"
          css={{
            border: '2px solid #021546',
            borderRadius: 15,
            left: '50%',
            maxWidth: '400px',
            width: '100%',
            [breakpoints.medium]: {
              maxWidth: 'none',
              width: 650,
            },
            transform: 'translateX(-50%)',
          }}
        >
          <CrossIcon
            css={{
              position: 'absolute',
              zIndex: 2,
              right: 0,
              [breakpoints.medium]: {
                margin: 20,
                width: 38,
              },
              margin: 10,
              width: 30,
              cursor: 'pointer',
            }}
            onClick={closeModal}
          />
          <Card>
            <Header1
              css={{
                padding: '0 20px 0 20px',
                textAlign: 'center',
                fontSize: '1.05rem',
                [breakpoints.medium]: {
                  fontSize: '2.25rem',
                  padding: '0 20px 20px 20px',
                },
              }}
            >
              {children}
            </Header1>
            <Flex
              flexDirection="column"
              width={230}
              alignSelf="center"
              gridGap={2}
              css={{
                scale: '70%',
                [breakpoints.medium]: {
                  scale: '100%',
                },
              }}
            >
              <ButtonLink
                variant="primary"
                to="/sign-up"
                state={{
                  returnTo: locationPathname,
                  fromModal: fromModal,
                }}
              >
                Sign Up
              </ButtonLink>
              <ButtonLink
                variant="primary"
                to="/log-in"
                css={{
                  ...gradientBorder(gradients.blueMint),
                }}
                state={{returnTo: locationPathname}}
              >
                Log In
              </ButtonLink>
            </Flex>
            <Body
              fontSize={{md: '1rem', default: '0.85rem'}}
              mt={{md: 3, default: 0}}
              textAlign="center"
            >
              Get Schooled never sells your data
            </Body>
          </Card>
        </Box>
      )}
    </>
  )
}

export default LoginModal
